// extracted by mini-css-extract-plugin
export default {"cls1":"Autocomplete-cls1_vOA","cls2":"Autocomplete-cls2_SZK Autocomplete-cls1_vOA","active":"Autocomplete-active__1w"};